module.exports = "/_next/static/images/Group-4582-05620a464badeae9514fb2f422a16754.svg";